export default __webpack_public_path__ + "static/media/noa-25.a3c58d03.jpg";